import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EndUserInstanceType } from "../types/EndUserInstanceType";
import { apiClient } from "src/utils/Api/apiClient";

interface endUserInstanceState {
        endUserInstances: Array<EndUserInstanceType>;
        endUserInstancesLoading: boolean;
        endUserInstancesError: string | null;
}

const initialState: endUserInstanceState = {
        endUserInstances: [],
        endUserInstancesLoading: true,
        endUserInstancesError: null
}

export const getEndUserInstances = createAsyncThunk(
        'endUserInstance/getEndUserInstances',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstance/getEndUserInstances/${endUserInstanceData}`);
                        return response.data;
                } catch (endUserInstanceError: any) {
                        return rejectWithValue(endUserInstanceError.response.data || 'An error occured');
                }
        }
);

export const deleteEndUserInstance = createAsyncThunk(
        'endUserInstance/deleteEndUserInstance',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('endUserInstance/deleteEndUserInstance', endUserInstanceData).then();
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

export const getEndUserInstancesByEndUserID = createAsyncThunk(
        'endUserInstance/getEndUserInstancesByEndUserID',
        async (endUserInstanceData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`endUserInstance/getEndUserInstancesByEndUserID/${endUserInstanceData}`);
                        return response.data;
                } catch (endUserInstanceError: any) {
                        return rejectWithValue(endUserInstanceError.response.data || 'An error occured');
                }
        }
);

const endUserInstancesSlice = createSlice({
        name: 'endUserInstances',
        initialState,
        reducers: {
                endUserInstancesReset: () => initialState,
                insertEndUserInstance: (state, action) => {
                        const id = action.payload.Id;
                        const index = state.endUserInstances.findIndex(item => item.Id === id);
                        if (index !== -1) {
                                state.endUserInstances[index] = action.payload;
                        }
                        else {
                                state.endUserInstances.push(action.payload);
                        }
                },
        },
        extraReducers: (builder) => {
                //get endUserInstances from server
                builder.addCase(getEndUserInstances.pending, (state) => {
                        state.endUserInstancesLoading = true;
                        state.endUserInstancesError = null;
                });
                builder.addCase(getEndUserInstances.fulfilled, (state, action) => {
                        state.endUserInstancesLoading = false;
                        state.endUserInstances = action.payload;
                });
                builder.addCase(getEndUserInstances.rejected, (state, action) => {
                        state.endUserInstancesLoading = false;
                        state.endUserInstancesError = action.payload as string;
                });

                //get endUserInstances from server by enduser id
                builder.addCase(getEndUserInstancesByEndUserID.pending, (state) => {
                        state.endUserInstancesLoading = true;
                        state.endUserInstancesError = null;
                });
                builder.addCase(getEndUserInstancesByEndUserID.fulfilled, (state, action) => {
                        state.endUserInstancesLoading = false;
                        state.endUserInstances = action.payload;
                });
                builder.addCase(getEndUserInstancesByEndUserID.rejected, (state, action) => {
                        state.endUserInstancesLoading = false;
                        state.endUserInstancesError = action.payload as string;
                });

                //delete endUserInstance from server
                builder.addCase(deleteEndUserInstance.pending, (state) => {
                        state.endUserInstancesLoading = true;
                        state.endUserInstancesError = null;
                });
                builder.addCase(deleteEndUserInstance.fulfilled, (state, action) => {
                        state.endUserInstancesLoading = false;
                        const id = action.payload.Id;
                        state.endUserInstances = state.endUserInstances.filter(item => item.Id !== parseInt(id));
                });
                builder.addCase(deleteEndUserInstance.rejected, (state, action) => {
                        state.endUserInstancesLoading = false;
                        state.endUserInstancesError = action.payload as string;
                });

        }
});

export const { endUserInstancesReset, insertEndUserInstance } = endUserInstancesSlice.actions;
export default endUserInstancesSlice.reducer;
